import gql from "graphql-tag"

export const sitePreviewTargetFragment = gql`
  fragment sitePreviewTargetFragment on Site {
    description
    previewDirectory
    branch
    publicName
    sitePrefix
  }
`
